/**
 * Portal "Ask Ava" → buyer chat deep link for a specific listing.
 * BuyerChat consumes ?ask=property and starts a thread about that home.
 * Address and city stay off the URL and off the synthesized user turn —
 * the server pins the listing from property_id (mls is a fallback).
 */

export function buildAskPropertyChatPath(slug, {
  propertyId = null,
  mlsNumber = null,
} = {}) {
  if (!slug) return '/chat';
  const qs = new URLSearchParams();
  qs.set('ask', 'property');
  if (propertyId) qs.set('property_id', String(propertyId));
  if (mlsNumber) qs.set('mls', String(mlsNumber));
  return `/chat/${slug}?${qs.toString()}`;
}

/**
 * @returns {null | { propertyId: string|null, mlsNumber: string|null, prompt: string }}
 */
export function parseAskPropertySearch(search) {
  const params = new URLSearchParams(search || '');
  if (params.get('ask') !== 'property') return null;

  const propertyId = (params.get('property_id') || '').trim() || null;
  const mlsNumber = (params.get('mls') || '').trim() || null;

  // Ignore leftover address/city params from older links. They must not
  // become the buyer's words or a search area.
  if (!propertyId && !mlsNumber) return null;

  return {
    propertyId,
    mlsNumber,
    prompt: 'Tell me about this listing',
  };
}
